import { render, staticRenderFns } from "./examlist.vue?vue&type=template&id=0236c386&scoped=true"
import script from "./examlist.vue?vue&type=script&lang=js"
export * from "./examlist.vue?vue&type=script&lang=js"
import style0 from "./examlist.vue?vue&type=style&index=0&id=0236c386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236c386",
  null
  
)

export default component.exports